import React, { useRef } from "react";

// Components
import { Input as InputBase, Tooltip } from "antd";

import { Label, InputWrapper, RedText, Text } from "./Input.styles";

const checkElementOverflown = ({ clientWidth, clientHeight, scrollWidth, scrollHeight }: HTMLDivElement) => {
  return scrollHeight > clientHeight || scrollWidth > clientWidth;
};
interface Props {
  label?: string;
  placeholder?: string;
  required?: boolean;
  textarea?: boolean;
  disabled?: boolean;
  defaultValue?: string;
  handleChange?: (value: string) => void;
  type?: "dimension";
  minHeight?: number;
  displayOnly?: boolean;
  color?: string;
  fontWeight?: number;
}

const Input: React.FC<Props> = ({
  label,
  placeholder,
  required,
  textarea,
  disabled,
  defaultValue,
  handleChange,
  type,
  minHeight,
  displayOnly,
  color,
  fontWeight,
}) => {
  const textRef = useRef<HTMLDivElement>(null);

  const renderInput = () => {
    const isOverFlown = textRef.current && checkElementOverflown(textRef.current);
    if (displayOnly)
      return (
        <Tooltip title={isOverFlown ? defaultValue : null} autoAdjustOverflow>
          <Text color={color} fontWeight={fontWeight} ref={textRef}>
            {defaultValue || "-"}
          </Text>
        </Tooltip>
      );

    if (textarea)
      return (
        <InputBase.TextArea
          key={defaultValue}
          disabled={disabled}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onBlur={(e) => {
            handleChange && handleChange(e.target.value);
          }}
        />
      );
    return (
      <InputBase
        key={defaultValue}
        onFocus={type === "dimension" ? (e) => e.target.select() : () => null}
        disabled={disabled}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onBlur={(e) => {
          handleChange && handleChange(e.target.value);
        }}
      />
    );
  };

  return (
    <InputWrapper minHeight={minHeight} disabled={disabled}>
      {label && type !== "dimension" ? (
        <Label>
          {label}
          {required ? <RedText>*</RedText> : null}
        </Label>
      ) : null}
      {renderInput()}
    </InputWrapper>
  );
};

export default Input;
